/** @jsx jsx */

import React, { Fragment as _, memo, useMemo, createContext } from 'react';
import { css, jsx } from '@emotion/core';
import EditableText from 'components/lib/EditableText';
import getTempTextImageData from 'services/getTempTextImageContinueBtnData';
import renderBlock from 'services/apiHelpers/renderBlock';
import { Row, Column } from '@chameleoncreator/creator-ui';
import ContinueBtn from 'components/lib/ContinueBtn/continueBtn_v2';
import Container from 'components/Layouts/ContainerLogical';
import { interactionContext } from './interactionContext';
import Matching from './Matching';
import getBlockById from 'services/apiHelpers/getBlockById';
import { Block } from '@chameleoncreator/creator-app';
import EditableBtn from 'components/lib/EditableBtn';
import IELayout from 'components/Layouts/IELayout';
import Image from 'components/lib/Image';
import Media from 'components/lib/Media';
import Video from 'components/lib/Video';
import Audio from 'components/lib/Audio';
import Transcript from 'components/lib/Video/Transcript';
import SVG from 'components/lib/SVG';
import Embed from 'components/lib/Embed';
import getMediaParent from 'services/apiHelpers/getMediaParent';
import MatchDrag from './MatchDrag';
import MatchDrop from './MatchDrop';
import shouldUpdate from 'services/shouldUpdate';
import imagePlaceholder from 'assets/Square.png';
//Flip2.png';

const SingleColumnLayout = Row.bind({}) as any;
SingleColumnLayout.defaultProps = {
  ...(Row as any).defaultProps,
  flexDirection: 'column',
};

const TwoColumnLayout = Row.bind({}) as any;
TwoColumnLayout.defaultProps = {
  ...(Row as any).defaultProps,
  flexDirection: 'row',
};

const Components = {
  Row,
  Column,
  // Text: EditableText,
  Text: ({ children, ...props }) => (
    <EditableText {...{ ...props, className: 'matching-text' }} />
  ),
  TwoColumnLayout: TwoColumnLayout,
  SingleColumnLayout: SingleColumnLayout,
  ContinueButton: ContinueBtn,
  EditableButton: EditableBtn,
  // Image,
  Image: ({ children, ...props }) => {
    const mediaParent = getMediaParent(props.id);

    //
    return mediaParent ? (
      <Image
        {...{
          ...props,
          placeholder: imagePlaceholder,
          editWrapperType: 1,
        }}
      />
    ) : (
      <Image {...props} />
    );
  },
  Video,
  Audio,
  SVG,
  Embed,
  Media,
  PDF: () => null,
  OpenPDF: () => null,
  Transcript,
  MatchPairs: ({ children, ...props }) => children,
  Matching,
  MatchDrag,
  MatchDrop,
  DragContainer: ({ children, ...props }) => children,
  DropContainer: ({ children, ...props }) => children,
  AnswerContainer: ({ children, ...props }) => null,
  Answer: () => null,
  Feedback: ({ children, ...props }) => children,
  Correct: ({ children, ...props }) => children,
  Incorrect: ({ children, ...props }) => children,
  Modal: () => null,
  ModalWithEditableBtn: () => null,
  ...IELayout(interactionContext),
};

const MatchingDisplay = memo((props: any) => {
  const interactionBlock = getBlockById(props.blockId);
  return (
    <Container
      id={interactionBlock.id}
      key={interactionBlock.id}
      {...interactionBlock.props}
      {...props}
    >
      <interactionContext.Provider
        value={{ ...interactionBlock, updateItemsSeen: null }}
      >
        {(interactionBlock.children as Block[]).map(child => {
          return renderBlock(child, Components);
        })}
      </interactionContext.Provider>
    </Container>
  );
}, shouldUpdate as any);

export default MatchingDisplay;
